import analyticsEvent from 'services/analytic/analytic-service';

const sendAnalyticsEventForTradeIn = ({ gaLabel = '' } = {}) => {
  analyticsEvent({
    gaAction: 'Product Page',
    gaLabel,
  });
};

export default sendAnalyticsEventForTradeIn;
